module.exports = __webpack_public_path__ + "img/1467177401.e39f7122.jpg";